'use client';

import type { ReactNode } from 'react';
import { useTokenExpiry } from '../../hooks/useTokenExpiry';
import TokenExpiryModal from './TokenExpiryModal';

interface TokenExpiryProviderProps {
  children: ReactNode;
  warningTime?: number; // seconds before expiry to show warning
  checkInterval?: number; // milliseconds between checks
}

export const TokenExpiryProvider: React.FC<TokenExpiryProviderProps> = ({
  children,
  warningTime = 60, // 1 minute default (reduced from 5 minutes)
  checkInterval = 60000, // 30 seconds default
}) => {
  const { showExpiryModal, timeRemaining, closeExpiryModal, handleSignOut } =
    useTokenExpiry({
      warningTime,
      checkInterval,
    });
  return (
    <>
      {children}
      {/* <TokenExpiryModal
        isOpen={showExpiryModal}
        onClose={closeExpiryModal}
        onSignOut={handleSignOut}
        timeRemaining={timeRemaining}
      /> */}
    </>
  );
};
